import React, { useState, useRef } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import bgimage from '../../../../images/product/default_product.png';
import { Button } from 'react-bootstrap';
import swal from "sweetalert2";

const AddProduct = () => {
    const [isVisible, setIsVisible] = useState({
        items: false,
    });
    const toggleDiv = (section) => {
        setIsVisible((prev) => ({
            ...prev,
            [section]: !prev[section], 
        }));
    }; 

    const options_product = [
        { value: "0", label: "Select Product Category" },
        { value: "1", label: "Break Fast" },
        { value: "2", label: "Lunch Box" },
        { value: "3", label: "Dinner" },
    ];
    const options_items = [
        { value: "0", label: "Select Items" },
        { value: "1", label: "Idly - Podi Idly - Steamed Food" },
        { value: "2", label: "Red Rice Puttu - Puttu - Steamed Food" },
        { value: "3", label: " Masal Dosai - Dosai - Rice Based Food" },
    ];

    const [selectedOption, setSelectedOption] = useState(null);
    const [file, setFile] = React.useState(null)
    const imageInputRef = useRef(null);
    const fileHandler = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    }

    const RemoveImage = () => {
        setFile(null);
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };

        const ConfirmationModal = () => {
            swal.fire({
                html: `
                      <div class="alert alert-success px-2 py-2" role="alert">
                          Are You Want to Create Product
                          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                      </div>
                      <p class="text-center"><b>Break Box</b></p>
                      <div class="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" 
                          // viewBox="0 0 48 48" width="48" height="48">
                          // <defs>
                          // <style>.cls-2{fill:#273941}.cls-5{fill:#f6fafd}
                          // </style></defs>
                          // <g id="_03-smile" data-name="03-smile"><circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                          // <path class="cls-2" d="M24 39c-7.168 0-13-4.935-13-11h2c0 4.962 4.935 9 11 9s11-4.038 11-9h2c0 6.065-5.832 11-13 11zM20 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6zM38 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6z"/>
                          // <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style="fill:#ffe369"/>
                          // <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style="fill:#ffb32b"/>
                          // <ellipse class="cls-5" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)"/>
                          // <ellipse class="cls-5" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)"/>
                          // <ellipse class="cls-5" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)"/></g>
                          // </svg>
                      </div>
                  `,
                showCancelButton: true,
                confirmButtonText: 'Yes!',
                cancelButtonText: 'No',
                reverseButtons: true,
                customClass: {
                    title: 'fs-6',
                    cancelButton: 'btn btn-sm btn-secondary',
                    confirmButton: 'btn btn-sm btn-success',
                    htmlContainer: 'text-left'
                },
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    swal.fire({
                        title: 'Product Created Successfully!',
                        text: `Break Box`,
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonText: 'OK',
                        customClass: {
                            title: 'fs-6',
                            confirmButton: 'btn btn-sm btn-primary',
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(() => {
                        window.location.href = './manage-products';
                        window.location.reload();
                    });
                } else {
                    swal.fire({
                        title: 'Create Process Cancelled',
                        text: `Break Box`,
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonText: 'OK',
                        customClass: {
                            title: 'fs-6',
                            confirmButton: 'btn btn-sm btn-primary',
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }
            });
        };
    
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#ea1d25' }}>Add Products</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Menus</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Products</li>
                    </ol>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Product Category<span className="required">*</span></label>
                    <Select placeholder={'Select Product Category'}
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options_product}
                    />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Product Type<span className="required">*</span></label>
                    <div className='mt-2'>
                        <div className="form-check-inline me-5">
                            <input
                                className="form-check-input me-1"
                                type="radio"
                                name="product_type"
                                value="option1"
                                defaultChecked
                            />
                            <label className="form-check-label text-black font-w400 fs-7">
                                Mini
                            </label>
                        </div>
                        <div className="form-check-inline">
                            <input
                                className="form-check-input me-1"
                                type="radio"
                                name="product_type"
                                value="option2"
                            />
                            <label className="form-check-label text-black font-w400 fs-7">
                                Regular
                            </label>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Product Name <span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Product Name" />
                </div>
                <div className="col-lg-8 mb-4">
                    <label className="text-black font-w500 fs-7">Description</label>
                    <textarea rows={4} className="form-control" name="comment" placeholder="Description" />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Product Image</label>
                    <div className="avatar-upload d-flex align-items-center">
                        <div className="change position-relative px-0">
                            <div className="avatar-preview h-100px w-100px border" style={{ borderRadius: '10px' }}>
                                <img
                                    id="saveImageFile"
                                    src={file ? URL.createObjectURL(file) : bgimage}
                                    alt={file ? file.name : 'Default Avatar'}
                                    className="p-1 h-100px w-100px"
                                />
                            </div>
                            <div className="change-btn">
                                <input
                                    type="file"
                                    id="imageUpload"
                                    accept=".png, .jpg, .jpeg"
                                    style={{ display: 'none' }}
                                    onChange={fileHandler}
                                    ref={imageInputRef}
                                />
                                <div className="mt-2 d-flex justify-content-center gap-3">
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="success"
                                        onClick={() => imageInputRef.current.click()}
                                    >
                                        <span className="">
                                            <i className="fa fa-upload color-success fs-4" />
                                        </span>
                                    </Button>
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="danger"
                                        onClick={RemoveImage}
                                    >
                                        <span className="">
                                            <i className="fa fa-close color-danger fs-4" />
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Main Dish (In Count)<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Main Dish" />
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Side Dish (In Count)<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Side Dish" />
                </div>
                <div className='col-lg-4 mb-4 d-flex align-items-center'>
                    <Link to={'#'} type="submit" className="mt-4 btn btn-sm btn-primary fs-7" onClick={() => toggleDiv('items')}>Get Item</Link>
                </div>
                {isVisible.items && (
                    <>
                        <div className="col-lg-6 mt-2 border-end">
                            <label className='fs-4 text-danger font-w600 mt-2'>Main Dish</label>
                            <div className="row mt-3">
                                <div className="col-lg-12 mb-4">
                                    <label className="text-black font-w500 fs-7">Items 1<span className="required">*</span></label>
                                    <Select placeholder={'Select Item'}
                                        defaultValue={selectedOption}
                                        onChange={setSelectedOption}
                                        options={options_items}
                                    />
                                </div>
                                <div className="col-lg-12 mb-4">
                                    <label className="text-black font-w500 fs-7">Items 2<span className="required">*</span></label>
                                    <Select  placeholder={'Select Item'}
                                        defaultValue={selectedOption}
                                        onChange={setSelectedOption}
                                        options={options_items}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-2">
                            <label className='fs-4 text-danger font-w600 mt-2'>Side Dish</label>
                            <div className="row mt-3" >
                            <div className="col-lg-12 mb-4">
                                    <label className="text-black font-w500 fs-7">Items<span className="required">*</span></label>
                                    <Select  placeholder={'Select Item'}
                                        defaultValue={selectedOption}
                                        onChange={setSelectedOption}
                                        options={options_items}
                                    />
                                </div>
                                <div className="col-lg-12 mb-4">
                                    <label className="text-black font-w500 fs-7">Items<span className="required">*</span></label>
                                    <Select  placeholder={'Select Item'}
                                        defaultValue={selectedOption}
                                        onChange={setSelectedOption}
                                        options={options_items}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={'/manage-products'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                <Link  type="submit" className="btn btn-sm btn-primary" onClick={ConfirmationModal}>Create Products</Link>
            </div>
        </>
    )


}
export default AddProduct;